import { HisBasic } from "./HisBasic";


/*
* 特作行: BOO問卷.xlsx 的 一行
* 一份特作，一人多行，且每Chapter解碼方式可能都不同
*/

export class HisRow {
  檢查日期: string = "";
  公司編號: string = "";
  作業編號: string = "";
  身份證號: string = "";

  類別: string = "";
  項目: string = "";
  結果: string = "";
  備註: string = "";

  constructor(基本檔: HisBasic, HIS類別代碼: string) {
    this.檢查日期 = 基本檔.檢查日期;
    this.公司編號 = 基本檔.公司編號;
    this.作業編號 = 基本檔.作業編號;
    this.身份證號 = 基本檔.身份證號;

    this.類別 = HIS類別代碼;
  }

}











/**
 * 轉檔的步驟定義
 */
export class SpwkHisStep {

  HIS類別代碼 = "";
  Chapter = "";

  constructor(HIS類別代碼: string, Chapter: string) {
    this.HIS類別代碼 = HIS類別代碼;
    this.Chapter = Chapter;
  }


  //  1.檢查時期(原因) 、2.作業經歷、3.既往病史、4.生活習慣、5.自覺症狀、6.疲勞狀況、7.作業環境監測資料

}




// const SpwkHisStepList: SpwkHisStep[] = [
//   new SpwkHisStep("1", "檢查時期(原因)"),
//   new SpwkHisStep("2", "作業經歷"),
//   new SpwkHisStep("3", "既往病史"),
//   new SpwkHisStep("4", "生活習慣"),
//   new SpwkHisStep("5", "自覺症狀"),
//   new SpwkHisStep("6", "疲勞狀況"),
//   new SpwkHisStep("7", "作業環境監測資料"),
// ];